export const SMALL_SCREEN_SIZE_BREAKPOINT = 450;
export const MID_SCREEN_SIZE_BREAKPOINT = 850;
export const LARGE_SCREEN_SIZE_BREAKPOINT = 1200;